// extracted by mini-css-extract-plugin
export default {"wrapper":"d1-z","play":"e1-z"};